import { criarInstanciador } from '@/uteis/action/atribuir/instanciador'

export const importar = (numeroProtocolo, dadosSessao, alteracoes) => {
  for (const index in alteracoes) {
    const value = alteracoes[index]
    if (value === '') {
      delete alteracoes[index]
    }
  }

  var dados = {
    numeroProtocolo: numeroProtocolo,
    responsavelImportacao: criarInstanciador(dadosSessao),
    edicao: alteracoes
  }

  return dados
}
